import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Menu, Button } from "antd";
import {
  AppstoreOutlined,
  KeyOutlined,
  CrownOutlined,
  PieChartOutlined,
  DatabaseOutlined,
  UnorderedListOutlined,
  TableOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  EnvironmentOutlined,
} from "@ant-design/icons";

export type MenuId = 'api-market' | 'api-key' | 'api-benefits' | 'api-usage' | 'data-market' | 'data-benefits';

interface SidebarProps {
  activeMenu: MenuId;
  onMenuChange: (id: MenuId) => void;
}

const menuItems: any = [
  {
    key: 'api-group',
    label: '数源 · API',
    icon: <UnorderedListOutlined />,
    children: [
      { key: 'api-market' as MenuId, label: 'API 集市', icon: <AppstoreOutlined /> },
      { key: 'api-key' as MenuId, label: 'API Key', icon: <KeyOutlined /> },
      { key: 'api-benefits' as MenuId, label: 'API 权益', icon: <CrownOutlined /> },
      { key: 'api-usage' as MenuId, label: 'API 用量', icon: <PieChartOutlined /> },
    ]
  },
  {
    key: 'data-group',
    label: '数源 · 数据库集',
    icon: <DatabaseOutlined />,
    children: [
      { key: 'data-market' as MenuId, label: '数据集市', icon: <TableOutlined /> },
      { key: 'data-benefits' as MenuId, label: '数据权益', icon: <CrownOutlined /> },
    ]
  },
  {
    key: 'ezt-map',
    label: 'e智图',
    icon: <EnvironmentOutlined />,
  }
];

export default function Sidebar({ activeMenu, onMenuChange }: SidebarProps) {
  const navigate = useNavigate();
  const [openKeys, setOpenKeys] = useState<string[]>(['api-group']);

  const handleOpenChange = (keys: string[]) => {
    setOpenKeys(keys);
  };

  const handleClick = ({ key }: { key: string }) => {
    if (key === 'ezt-map') {
      window.open('https://www.daditu.com.cn/zxzt/mapping.html', '_blank');
      return;
    }
    const validKeys: MenuId[] = ['api-market', 'api-key', 'api-benefits', 'api-usage', 'data-market', 'data-benefits'];
    if (validKeys.includes(key as MenuId)) {
      onMenuChange(key as MenuId);
    }
  };

  const [collapsed, setCollapsed] = useState(false);
  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  return (
    <div className={`bg-white flex flex-col shrink-0 transition-all duration-200 h-[calc(100vh-3.5rem)] shadow-lg`}>
      {/* 收起/展开按钮 */}
      <div className={`p-3 border-b border-gray-100 min-w-[80px] items-center ${collapsed ? 'flex justify-center' : 'flex justify-start ml-1'}`}>
        <button
          onClick={toggleCollapsed}
          className="p-2 rounded hover:bg-gray-100 transition-colors"
        >
          {collapsed ? <MenuUnfoldOutlined className="text-gray-600 text-xl" /> : <MenuFoldOutlined className="text-gray-600 text-xl" />}
        </button>
        {!collapsed ? <span>收起</span> : <span></span>}
      </div>

      <Menu
        mode="inline"
        selectedKeys={[activeMenu]}
        openKeys={openKeys}
        onOpenChange={handleOpenChange}
        onClick={handleClick}
        items={menuItems}
        inlineCollapsed={collapsed}
        /* style={{
          height: '100%',
          borderRight: 0,
          overflow: 'hidden'
        }} */
      />
    </div>
  );
}